import { englishPhrases } from 'libs/end-to-end/src/english-phrases';
import { englishPhrasesPd } from 'libs/end-to-end/src/english-phrases-pd';
import { LanguageName } from 'libs/end-to-end/src/language';
import { Phrases } from 'libs/end-to-end/src/phrases';

export const Languages: Record<LanguageName, Phrases> = {
  en: englishPhrases,
  'en-pd': englishPhrasesPd,
};

export const getLanguage = (language: LanguageName): Phrases => {
  if (language in Languages) {
    return Languages[language];
  }
  return Languages.en; // Fallback to English if the language is not found
};
